import React from 'react';
import { Typography, Tooltip, useTheme } from '@mui/material';
import { formatToUtcTime } from 'utils/dateUtils';

interface CellDateTimeUTCProps {
  params: any;
  onClick?: () => void;
}

const CellDateTimeUTC = ({ params, onClick }: CellDateTimeUTCProps) => {
  const theme = useTheme();
  const rawValue = params?.value;
  const formattedDateTime = rawValue ? formatToUtcTime(rawValue) : '--';
  const displayValue = formattedDateTime && formattedDateTime !== 'Invalid Date'
    ? formattedDateTime
    : '--';

  return (
    <Tooltip title={displayValue}>
      <Typography
        component="span"
        sx={{
          fontSize: '14px',
          color: theme.palette.text.primary,
          cursor: onClick ? 'pointer' : 'default',
        }}
        onClick={onClick}
      >
        {displayValue}
      </Typography>
    </Tooltip>
  );
};

export default CellDateTimeUTC;
